import React from 'react';
import Header from '../components/header';
import BreadCrumbsBar from '../components/breadCrumbsBar';
import Footer from '../components/footer';
import ContactCentre from '../components/contactCentre';
function ContactCentrePage() {
    return (
      <div>
        <Header />
        <BreadCrumbsBar />
        <ContactCentre />
        <Footer />
      </div>
    );
  }

 export default ContactCentrePage; 
  
  